// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.dropdown-select {
  width: 30em !important;
}
.dropdown-operator {
  display: flex;
  gap: 1em;
  padding-left: 0.5em;
  color: #777776;
  font-size: 0.9em;
}
.dropdown-operator-container {
  padding-left: 0.5em;
}
.dropdown-operator span:not(:first-child) {
  margin-left: -0.7em;
}
.dropdown-operator-feedback {
  color: #777776;
  font-size: 0.8em;
  margin-left: 1em !important;
}
.dropdown-operator-selected {
  color: black;
  font-weight: 500;
}
.dropdown-title {
  font-size: 1.5em;
  font-weight: bold;
  margin: 0;
  margin-bottom: 0.5em;
}
.dropdown-container {
  flex: 1 1;
  margin-inline: 2em;
  padding: 2em;
  border-radius: 1em;
  background-color: #fff;
  overflow: scroll;
  margin-top: 1em;
  height: calc(100% - 2em);
}
.dropdown-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dropdown-header-action, .dropdown-header-action:focus, .dropdown-header-action:hover, .dropdown-header-action:active {
  text-decoration: none;
  outline: none;
  box-shadow: none !important;
  background-color: #fff;
  border: 1px solid #8f003c;
  color: #8f003c;
  padding-inline: 2em;
  border-radius: 8px;
}
.dropdown-header-action:hover {
  background-color: #8f003c;
  color: #fff;
}
.dropdown-header-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dropdown-form-action-group {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1em;
  margin-right: 1em;
  gap: 1em;
}

.dropdown-form-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row !important;
  background-color: #f3f6f9;
  padding: 1em;
  border-radius: 1em;
  margin: 0.5em;
  gap: 1em;
}
.dropdown-form-option-value {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
}
.dropdown-form-option-title {
  margin: 1em;
  margin-bottom: 0;
  font-size: 1em;
}

.option-delete-button {
  cursor: pointer;
}

label {
  color: #777776;
  font-size: 14px;
}

.select-product {
  width: 50%;
}

.dropdown-option-action {
  align-self: flex-end;
  margin: 1em;
  margin-right: 0;
}

.options-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.options-container .form-row {
  justify-content: flex-end;
}

.dropdown-form-option-fields {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 1em;
}
.dropdown-form-option-fields .form-control {
  margin: 0;
}

.dropdown-form-option-add {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #8f003c;
  color: white;
  cursor: pointer;
  border-radius: 50%;
  width: 2em;
  height: 2em;
  padding: 1.1em;
}

.dropdown-form-option-link {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(50, 83, 173);
  color: white;
  cursor: pointer;
  border-radius: 50%;
  width: 2em;
  height: 2em;
  padding: 1.1em;
}

.dropdown-form-option-visibility {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(8, 131, 18);
  color: rgb(255, 255, 255);
  cursor: pointer;
  border-radius: 50%;
  width: 2em;
  height: 2em;
  padding: 1.1em;
}

.dropdown-form-option-table {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(15, 109, 31);
  color: white;
  cursor: pointer;
  border-radius: 50%;
  width: 2em;
  height: 2em;
  padding: 1.1em;
}

.second-level {
  width: 90% !important;
}

.third-level {
  width: 80% !important;
}`, "",{"version":3,"sources":["webpack://./src/components/views/dropdowns/dropdownForm/dropdownForm.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAGA;ECFC,aAAA;EACA,uBDEc;ECDd,uBDCsB;EACtB,SAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAAD;AAEC;EACC,sBAAA;AAAF;AAGC;EACC,aAAA;EACA,QAAA;EACA,mBAAA;EACA,cEXU;EFYV,gBAAA;AADF;AAGE;EACC,mBAAA;AADH;AAIE;EACC,mBAAA;AAFH;AAKE;EACC,cEvBS;EFwBT,gBAAA;EACA,2BAAA;AAHH;AAME;EACC,YAAA;EACA,gBAAA;AAJH;AAQC;EACC,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,oBAAA;AANF;AASC;EACC,SAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBEjDM;EFkDN,gBAAA;EACA,eAAA;EACA,wBAAA;AAPF;AAUC;EC1DA,aAAA;EACA,8BD0De;ECzDf,mBDyD8B;AAN/B;AAQE;EAIC,qBAAA;EACA,aAAA;EACA,2BAAA;EACA,sBEjEK;EFkEL,yBAAA;EACA,cEvEQ;EFwER,mBAAA;EACA,kBAAA;AATH;AAYE;EACC,yBE7EQ;EF8ER,WE1EK;AFgER;AAaE;EChFD,aAAA;EACA,8BDgFgB;EC/EhB,mBD+E+B;AAThC;;AAcA;ECtFC,aAAA;EACA,yBDsFc;ECrFd,mBDqFwB;EACxB,eAAA;EACA,iBAAA;EACA,QAAA;AATD;;AAYA;EC7FC,aAAA;EACA,8BD6Fc;EC5Fd,mBD4F6B;EAC7B,8BAAA;EACA,yBE5FM;EF6FN,YAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;AAPD;AASC;EChGA,aAAA;EACA,sBAAA;EACA,uBD+FqB;EC9FrB,uBD8F6B;EAC5B,WAAA;AAJF;AAOC;EACC,WAAA;EACA,gBAAA;EACA,cAAA;AALF;;AASA;EACC,eAAA;AAND;;AASA;EACC,cAAA;EACA,eAAA;AAND;;AASA;EACC,UAAA;AAND;;AASA;EACC,oBAAA;EACA,WAAA;EACA,eAAA;AAND;;AASA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;AAND;AAQC;EACC,yBAAA;AANF;;AAUA;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AAPD;AASC;EACC,SAAA;AAPF;;AAWA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBEhKU;EFiKV,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AARD;;AAWA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AARD;;AAWA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AARD;;AAWA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AARD;;AAWA;EACC,qBAAA;AARD;;AAWA;EACC,qBAAA;AARD","sourcesContent":["@import '../../../../sass/globals/globals.scss';\n@import '../../../../sass/globals/mixins.scss';\n\n.dropdown {\n\t@include flex(center, flex-start);\n\tflex: 1;\n\theight: 100%;\n\tbox-sizing: border-box;\n\toverflow: scroll;\n\n\t&-select {\n\t\twidth: 30em !important;\n\t}\n\n\t&-operator {\n\t\tdisplay: flex;\n\t\tgap: 1em;\n\t\tpadding-left: 0.5em;\n\t\tcolor: $dark-grey;\n\t\tfont-size: 0.9em;\n\n\t\t&-container {\n\t\t\tpadding-left: 0.5em;\n\t\t}\n\n\t\tspan:not(:first-child) {\n\t\t\tmargin-left: -0.7em;\n\t\t}\n\n\t\t&-feedback {\n\t\t\tcolor: $dark-grey;\n\t\t\tfont-size: 0.8em;\n\t\t\tmargin-left: 1em !important;\n\t\t}\n\n\t\t&-selected {\n\t\t\tcolor: black;\n\t\t\tfont-weight: 500;\n\t\t}\n\t}\n\n\t&-title {\n\t\tfont-size: 1.5em;\n\t\tfont-weight: bold;\n\t\tmargin: 0;\n\t\tmargin-bottom: .5em;\n\t}\n\n\t&-container {\n\t\tflex: 1;\n\t\tmargin-inline: 2em;\n\t\tpadding: 2em;\n\t\tborder-radius: 1em;\n\t\tbackground-color: $white;\n\t\toverflow: scroll;\n\t\tmargin-top: 1em;\n\t\theight: calc(100% - 2em);\n\t}\n\n\t&-header {\n\t\t@include flex(space-between, center);\n\n\t\t&-action,\n\t\t&-action:focus,\n\t\t&-action:hover,\n\t\t&-action:active {\n\t\t\ttext-decoration: none;\n\t\t\toutline: none;\n\t\t\tbox-shadow: none !important;\n\t\t\tbackground-color: $white;\n\t\t\tborder: 1px solid $dark-red;\n\t\t\tcolor: $dark-red;\n\t\t\tpadding-inline: 2em;\n\t\t\tborder-radius: 8px;\n\t\t}\n\n\t\t&-action:hover {\n\t\t\tbackground-color: $dark-red;\n\t\t\tcolor: $white;\n\t\t}\n\n\t\t&-search {\n\t\t\t@include flex(space-between, center);\n\t\t}\n\t}\n}\n\n.dropdown-form-action-group {\n\t@include flex(flex-end, center);\n\tmargin-top: 1em;\n\tmargin-right: 1em;\n\tgap: 1em;\n}\n\n.dropdown-form-option {\n\t@include flex(space-between, center);\n\tflex-direction: row !important;\n\tbackground-color: $grey;\n\tpadding: 1em;\n\tborder-radius: 1em;\n\tmargin: .5em;\n\tgap: 1em;\n\n\t&-value {\n\t\t@include flexColumn(center, flex-start);\n\t\twidth: 100%;\n\t}\n\n\t&-title {\n\t\tmargin: 1em;\n\t\tmargin-bottom: 0;\n\t\tfont-size: 1em;\n\t}\n}\n\n.option-delete-button{\n\tcursor: pointer;\n}\n\nlabel{\n\tcolor:#777776;\n\tfont-size: 14px;\n}\n\n.select-product{\n\twidth: 50%;\n}\n\n.dropdown-option-action{\n\talign-self: flex-end;\n\tmargin: 1em;\n\tmargin-right: 0;\n}\n\n.options-container{\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t.form-row{\n\t\tjustify-content: flex-end;\n\t}\n}\n\n.dropdown-form-option-fields{\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\twidth: 100%;\n\tgap: 1em;\n\t\n\t.form-control {\n\t\tmargin: 0;\n\t}\n}\n\n.dropdown-form-option-add{\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground-color: $dark-red;\n\tcolor: white;\n\tcursor: pointer;\n\tborder-radius: 50%;\n\twidth: 2em;\n\theight: 2em;\n\tpadding: 1.1em;\n}\n\n.dropdown-form-option-link{\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground-color: rgb(50, 83, 173);\n\tcolor: white;\n\tcursor: pointer;\n\tborder-radius: 50%;\n\twidth: 2em;\n\theight: 2em;\n\tpadding: 1.1em;\n}\n\n.dropdown-form-option-visibility{\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground-color: rgb(8, 131, 18);\n\tcolor: rgb(255, 255, 255);\n\tcursor: pointer;\n\tborder-radius: 50%;\n\twidth: 2em;\n\theight: 2em;\n\tpadding: 1.1em;\n}\n\n.dropdown-form-option-table{\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground-color: rgb(15, 109, 31);\n\tcolor: white;\n\tcursor: pointer;\n\tborder-radius: 50%;\n\twidth: 2em;\n\theight: 2em;\n\tpadding: 1.1em;\n}\n\n.second-level {\n\twidth: 90% !important;\n}\n\n.third-level {\n\twidth: 80% !important;\n}\n","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
